module.exports = __webpack_public_path__ + "static/img/4.96b62ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/4.png
// module id = zyzT
// module chunks = 0